var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Adsense',{staticClass:"RwvAdvertisement",attrs:{"data-ad-client":_vm.ad_client,"data-ad-slot":_vm.ad_slot,"data-ad-test":"on","data-ad-format":"auto"}})}
var staticRenderFns = []

export { render, staticRenderFns }